import { ProgramPreviewType } from './programPreview';
import {
	FLUSH_PROGRAM_PREVIEW,
	LOAD,
	LOAD_FAILURE,
	LOAD_SUCCESS,
	OVERWRITE,
	OVERWRITE_FAILURE,
	OVERWRITE_SUCCESS,
	REPLACE,
	REPLACE_FAILURE,
	REPLACE_SUCCESS,
	RESET_HAS_PROGRAM_CHANGED,
	START,
	START_FAILURE,
	START_SUCCESS,
} from './programPreview.actionTypes';

export const actionCreators = {
	doFlushCurrentPreview: () => ({
		type: FLUSH_PROGRAM_PREVIEW,
	}),
	doLoadPreview: (programId: string) => ({
		type: LOAD,
		programId,
	}),
	doLoadPreviewSuccess: (programPreviewData: Object) => ({
		type: LOAD_SUCCESS,
		programPreviewData,
	}),
	doLoadPreviewFailure: (error: Error) => ({
		type: LOAD_FAILURE,
		error,
	}),
	doStartProgram: (programId: string, date?: string) => ({
		type: START,
		programId,
		date,
	}),
	doStartProgramSuccess: (activeProgram: ProgramPreviewType) => ({
		type: START_SUCCESS,
		activeProgram,
	}),
	doStartProgramFailure: (response: Object) => ({
		type: START_FAILURE,
		response,
	}),
	doOverwriteProgram: (programId: string, date?: string) => ({
		type: OVERWRITE,
		programId,
		date,
	}),
	doOverwriteProgramSuccess: (activeProgram: ProgramPreviewType) => ({
		type: OVERWRITE_SUCCESS,
		activeProgram,
	}),
	doOverwriteProgramFailure: (response: Object) => ({
		type: OVERWRITE_FAILURE,
		response,
	}),
	doReplaceProgram: (programId: string, date?: string) => ({
		type: REPLACE,
		programId,
		date,
	}),
	doReplaceProgramSuccess: (activeProgram: ProgramPreviewType) => ({
		type: REPLACE_SUCCESS,
		activeProgram,
	}),
	doReplaceProgramFailure: (response: Object) => ({
		type: REPLACE_FAILURE,
		response,
	}),
	doResetHasProgramChanged: () => ({
		type: RESET_HAS_PROGRAM_CHANGED,
	}),
};

export type ProgramPreviewActionType =
	| ReturnType<typeof actionCreators.doFlushCurrentPreview>
	| ReturnType<typeof actionCreators.doLoadPreview>
	| ReturnType<typeof actionCreators.doLoadPreviewSuccess>
	| ReturnType<typeof actionCreators.doLoadPreviewFailure>
	| ReturnType<typeof actionCreators.doStartProgram>
	| ReturnType<typeof actionCreators.doStartProgramSuccess>
	| ReturnType<typeof actionCreators.doStartProgramFailure>
	| ReturnType<typeof actionCreators.doOverwriteProgram>
	| ReturnType<typeof actionCreators.doOverwriteProgramSuccess>
	| ReturnType<typeof actionCreators.doOverwriteProgramFailure>
	| ReturnType<typeof actionCreators.doReplaceProgram>
	| ReturnType<typeof actionCreators.doReplaceProgramSuccess>
	| ReturnType<typeof actionCreators.doReplaceProgramFailure>
	| ReturnType<typeof actionCreators.doResetHasProgramChanged>;
